import React from 'react';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { Flex } from '@televet/kibble-ui/build/chakra';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { Tooltip } from '@televet/kibble-ui/build/components/Tooltip';
import { Icon } from '@televet/kibble-ui/build/components/Icon';

interface ButtonActionContainerProps {
  label: string;
  description?: string;
  remove: () => void;
  children?: JSX.Element | null | undefined;
}

const ButtonActionContainer = ({ label, description, remove, children }: ButtonActionContainerProps): JSX.Element => {
  return (
    <Flex w="100%" direction="column" px={4} pt={2} pb={4} borderRadius={8} bgColor="background.subtle">
      <Flex w="100%" alignItems="center" justifyContent="space-between" pb={1}>
        <Flex gap={1} alignItems="center">
          <Text fontWeight="semibold">{label}</Text>
          {description && (
            <Tooltip label={description}>
              <Flex>
                <Icon name="infoCircle" size="xs" />
              </Flex>
            </Tooltip>
          )}
        </Flex>
        <Button variant="ghostNeutral" size="md" iconName="trashcan" onClick={remove} />
      </Flex>
      {children}
    </Flex>
  );
};

export default ButtonActionContainer;
